import { Typography } from '@mui/material'
import { useStyles } from '../DetailedOffer.styles'
import clsx from 'clsx'
import { DetailedOffer } from '../DetailedOffer'
import {
  AzureMeteringDimensions,
  BillingTerms,
} from '../../AzurePricingSection'
import { RecurrentPriceModeType } from '../../../../modules/privateOffer/types'
import { AzurePricingType } from '../../../../modules/privateOffer/types'
import { startCase } from 'lodash'

interface PlansSectionProps {
  offer: DetailedOffer
  isViewPage: boolean
}

export const PlansSection = ({ offer, isViewPage }: PlansSectionProps) => {
  const { classes } = useStyles()
  const { plans, azurePricingType } = offer
  const pricingTypeValue = `Pricing type : ${startCase(
    azurePricingType === AzurePricingType.LABRA_PERCENTAGE
      ? 'discount'
      : azurePricingType
  )}`

  return (
    <div className={classes.box}>
      <div
        className={clsx(classes.recipientBox, classes.generalPaddingAndWidth)}
      >
        <Typography className={classes.heading}>Pricing</Typography>
        <Typography
          className={clsx(classes.dataText, classes.customKeyValue)}
          data-testid="pricing-type"
        >
          {pricingTypeValue}
        </Typography>
        <div className={classes.plan}>
          {plans &&
            azurePricingType &&
            plans?.map((planRowData, index) => {
              const shouldShowMetering =
                planRowData.pricing?.recurrentPrice?.recurrentPriceMode ===
                  RecurrentPriceModeType.FLATRATE &&
                planRowData.pricing?.customMeters &&
                Object.keys(planRowData.pricing?.customMeters?.meters || {})
                  .length > 0
              const userLimitsData = {
                ...planRowData.pricing.recurrentPrice.userLimits,
              }
              const isPerUserPlan =
                planRowData.pricing.recurrentPrice.recurrentPriceMode
              const { min, minEnable, max, maxEnable } = userLimitsData
              const nonEditedUserLimitsData = {
                ...planRowData.originalPricing?.recurrentPrice.userLimits,
              }
              const minValue =
                minEnable || isViewPage ? min : nonEditedUserLimitsData.min
              const maxValue =
                maxEnable || isViewPage ? max : nonEditedUserLimitsData.max
              return (
                <div className={classes.planSectionRow}>
                  <div className={classes.planRow}>
                    <div className={classes.planNameLabelWidth}>
                      <div className={classes.descriptionTitle}>Plan name</div>
                      <p className={classes.description}>
                        {planRowData?.displayName}
                      </p>
                    </div>
                    <div className={classes.planDecLabelWidth}>
                      <div className={classes.descriptionTitle}>
                        Description
                      </div>
                      <p className={classes.description}>
                        {planRowData?.description || '-'}
                      </p>
                    </div>
                    {azurePricingType === AzurePricingType.LABRA_PERCENTAGE && (
                      <div className={classes.planNameLabelWidth}>
                        <div className={classes.descriptionTitle}>Discount</div>
                        <p
                          className={classes.description}
                          data-testid="discount"
                        >
                          {planRowData?.discountPercentage || '-'}
                        </p>
                      </div>
                    )}
                  </div>
                  <BillingTerms
                    azurePricingType={azurePricingType}
                    index={index}
                    planRow={planRowData}
                    isReadOnly={true}
                    isViewPage={isViewPage}
                  />
                  {shouldShowMetering && (
                    <AzureMeteringDimensions
                      index={index}
                      planRow={planRowData}
                      azurePricingType={azurePricingType}
                      isReadOnly={true}
                      isViewPage={isViewPage}
                    />
                  )}
                  {isPerUserPlan === RecurrentPriceModeType.PERUSER ? (
                    <>
                      <Typography
                        className={clsx(
                          classes.dataText,
                          classes.customKeyValue
                        )}
                        data-testid="pricing-type"
                      >{`Minimum users : ${minValue}`}</Typography>
                      <Typography
                        className={clsx(
                          classes.dataText,
                          classes.customKeyValue
                        )}
                        data-testid="pricing-type"
                      >{`Maximum users : ${maxValue}`}</Typography>
                    </>
                  ) : (
                    <></>
                  )}
                </div>
              )
            })}
        </div>
      </div>
    </div>
  )
}
